import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';

import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';

import type { LayoutProps } from './layout-types';

const styles = cssMap({
	leftColumnStyles: {
		width: '100%',
	},
	rightColumnStyles: {
		width: '295px',
	},
});

const REQUIRED_ELEMENTS_COUNT = 1;

export const TwoColumnLayout = ({ elements, key }: LayoutProps) => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return (
		<Inline space="space.200">
			<Box xcss={styles.leftColumnStyles}>
				{elements.map(
					(element) =>
						typeof element !== 'string' &&
						element.attributes?.pos === 'left' && (
							<DynamicLayoutComponent
								component={element}
								position="two-columns-left"
								key={`${key}-${element.attributes?.pos}`}
							/>
						),
				)}
			</Box>
			<Box xcss={styles.rightColumnStyles}>
				{elements.map(
					(element) =>
						typeof element !== 'string' &&
						element.attributes?.pos === 'right' && (
							<DynamicLayoutComponent
								component={element}
								position="two-columns-right"
								key={`${key}-${element.attributes?.pos}`}
							/>
						),
				)}
			</Box>
		</Inline>
	);
};
